var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.htmlTag,{tag:"component",staticClass:"cs-button",class:[
        'cs-button--size-' + _vm.size,
        _vm.pattern && _vm.color && 'cs-button--pattern-' + _vm.pattern + '-' + _vm.color,
        _vm.disabled && 'cs-button--disabled',
        _vm.fullWidth && 'cs-button--full-width',
        _vm.bold && 'cs-button--bold',
        _vm.narrow && 'cs-button--narrow'
    ],attrs:{"type":_vm.type,"disabled":_vm.disabled,"to":_vm.to},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.$slots['icon'])?_c('div',{staticClass:"cs-button__icon"},[(!_vm.loading)?_vm._t("icon"):_vm._e()],2):_vm._e(),(_vm.loading)?_c('cs-loader',{staticClass:"cs-button__loader",attrs:{"type":"button","size":"base"}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }